import { Component, inject } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import type { ICellRendererParams } from "ag-grid-community";
import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { BudgetUtils } from "@bitwarden/web-vault/app/models/view/budget/budget.utils";

@Component({
  selector: "app-variance-cell-renderer",
  templateUrl: "./variance.cell-renderer.component.html",
})
export class VarianceCellRenderer implements ICellRendererAngularComp {
  private i18nService = inject(I18nService);

  value: number | null = null;
  label: string = "";
  colorClass: string = "";
  tagClass: string = "";

  agInit(params: ICellRendererParams): void {
    this.updateValue(params.value);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateValue(params.value);
    return true;
  }

  private updateValue(value: number | null) {
    this.value = value ?? 0;
    this.colorClass = BudgetUtils.varianceTextClass(this.value);
    this.tagClass = BudgetUtils.varianceTagClass(this.value);
    this.label = this.value < 0 ? this.i18nService.t("overspent") : "";
  }
}
